var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "table-row"
  }, [_c('v-col', {
    staticClass: "table-th",
    attrs: {
      "cols": _vm.cols,
      "md": _vm.md
    }
  }, [_vm._v(_vm._s(_vm.label))]), _c('v-col', {
    staticClass: "table-td"
  }, [_vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }